// extracted by mini-css-extract-plugin
module.exports = {"lazy":"lazy-image_lazy__Bj1ka","lazyLoaded":"lazy-image_lazyLoaded__wIEEQ"};